import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhotoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_214_1956",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 52,
		height: 52,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 51.5,
			height: 51.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_214_1956)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.93766 45.0625C5.75745 45.0625 4.74712 44.6423 3.90667 43.8018C3.06622 42.9614 2.646 41.951 2.646 40.7708V15.0208C2.646 13.8406 3.06622 12.8303 3.90667 11.9898C4.74712 11.1494 5.75745 10.7291 6.93766 10.7291H13.697L17.6668 6.43748H30.5418V10.7291H19.5444L15.6283 15.0208H6.93766V40.7708H41.271V21.4583H45.5627V40.7708C45.5627 41.951 45.1424 42.9614 44.302 43.8018C43.4615 44.6423 42.4512 45.0625 41.271 45.0625H6.93766ZM41.271 15.0208V10.7291H36.9793V6.43748H41.271V2.14581H45.5627V6.43748H49.8543V10.7291H45.5627V15.0208H41.271ZM24.1043 37.5521C26.7866 37.5521 29.0666 36.6133 30.9442 34.7357C32.8218 32.8581 33.7606 30.5781 33.7606 27.8958C33.7606 25.2135 32.8218 22.9336 30.9442 21.056C29.0666 19.1784 26.7866 18.2396 24.1043 18.2396C21.422 18.2396 19.1421 19.1784 17.2645 21.056C15.3869 22.9336 14.4481 25.2135 14.4481 27.8958C14.4481 30.5781 15.3869 32.8581 17.2645 34.7357C19.1421 36.6133 21.422 37.5521 24.1043 37.5521ZM24.1043 33.2604C22.6022 33.2604 21.3326 32.7418 20.2955 31.7047C19.2583 30.6675 18.7397 29.3979 18.7397 27.8958C18.7397 26.3937 19.2583 25.1241 20.2955 24.087C21.3326 23.0498 22.6022 22.5312 24.1043 22.5312C25.6064 22.5312 26.876 23.0498 27.9132 24.087C28.9503 25.1241 29.4689 26.3937 29.4689 27.8958C29.4689 29.3979 28.9503 30.6675 27.9132 31.7047C26.876 32.7418 25.6064 33.2604 24.1043 33.2604Z",
			fill: "#84754E"
		})
	})]
});
export default SvgPhotoIcon;
